export const cities = [
  { rus: "Акко", en: "Akko", hebrew: "עכו" },
  { rus: "Арад", en: "Arad", hebrew: "ערד" },
  { rus: "Ашдод", en: "Ashdod", hebrew: "אשדוד" },
  { rus: "Ашкелон", en: "Ashkelon", hebrew: "אשקלון" },
  { rus: "Бар-Яхим", en: "Bar-Yahim", hebrew: "בר-יחים" },
  { rus: "Беэр-Шева", en: "Beersheba", hebrew: "באר שבע" },
  { rus: "Бейт-Шемеш", en: "Beit Shemesh", hebrew: "בית שמש" },
  { rus: "Гальим", en: "Galim", hebrew: "גלים" },
  { rus: "Ган-Явне", en: "Gan Yavne", hebrew: "גן יבנה" },
  { rus: "Гат-Тавор", en: "Gat-Tavor", hebrew: "גת תבור" },
  { rus: "Герцлия", en: "Herzliya", hebrew: "הרצליה" },
  { rus: "Гиватаим", en: "Givataim", hebrew: "גבעתיים" },
  { rus: "Гиват-Зев", en: "Givat Zev", hebrew: "גבעת זאב" },
  { rus: "Гиват-Шмуэль", en: "Givat Shmuel", hebrew: "גבעת שמואל" },
  { rus: "Димона", en: "Dimona", hebrew: "דימונה" },
  { rus: "Эйлат", en: "Eilat", hebrew: "אילת" },
  { rus: "Иерусалим", en: "Jerusalem", hebrew: "ירושלים" },
  { rus: "Кафр-Бирим", en: "Kafr Birim", hebrew: "כפר בירים" },
  { rus: "Кфар-Кана", en: "Kfar Qana", hebrew: "כפר קנא" },
  { rus: "Кесария", en: "Caesarea", hebrew: "קיסריה" },
  { rus: "Кирьят-Арба", en: "Kiryat Arba", hebrew: "קריית ארבע" },
  { rus: "Кирьят-Бялик", en: "Kiryat Bialik", hebrew: "קריית ביאליק" },
  { rus: "Кирьят-Гат", en: "Kiryat Gat", hebrew: "קריית גת" },
  { rus: "Кирьят-Хаим", en: "Kiryat Haim", hebrew: "קריית חיים" },
  { rus: "Кирьят-Малхи", en: "Kiryat Malakhi", hebrew: "קריית מלאכי" },
  { rus: "Кирьят-Маца", en: "Kiryat Matsa", hebrew: "קריית מצא" },
  { rus: "Кирьят-Моцкин", en: "Kiryat Motzkin", hebrew: "קריית מוצקין" },
  { rus: "Кирьят-Оно", en: "Kiryat Ono", hebrew: "קריית אונו" },
  { rus: "Кирьят-Шмона", en: "Kiryat Shmona", hebrew: "קריית שמונה" },
  { rus: "Кирьят-Ям", en: "Kiryat Yam", hebrew: "קריית ים" },
  { rus: "Кирьят-Цви", en: "Kiryat Zvi", hebrew: "קריית צבי" },
  { rus: "Кармиэль", en: "Carmiel", hebrew: "כרמיאל" },
  { rus: "Кфар-Сава", en: "Kfar Saba", hebrew: "כפר סבא" },
  { rus: "Лахиш", en: "Lachish", hebrew: "לחיש" },
  { rus: "Лод", en: "Lod", hebrew: "לוד" },
  { rus: "Маанит", en: "Maanit", hebrew: "מענית" },
  { rus: "Маале-Адумим", en: "Maale Adumim", hebrew: "מעלה אדומים" },
  { rus: "Мигдаль-ха-Эмек", en: "Migdal HaEmek", hebrew: "מגדל העמק" },
  { rus: "Модиин", en: "Modiin", hebrew: "מודיעין" },
  { rus: "Нагария", en: "Nahariya", hebrew: "נהריה" },
  { rus: "Нетания", en: "Netanya", hebrew: "נתניה" },
  { rus: "Нешер", en: "Nesher", hebrew: "נשר" },
  { rus: "Петах-Тиква", en: "Petah Tikva", hebrew: "פתח תקווה" },
  { rus: "Рамат-Ган", en: "Ramat Gan", hebrew: "רמת גן" },
  { rus: "Рамат-Шарон", en: "Ramat Hasharon", hebrew: "רמת השרון" },
  { rus: "Рамле", en: "Ramle", hebrew: "רמלה" },
  { rus: "Реховот", en: "Rehovot", hebrew: "רחובות" },
  { rus: "Ришон-ле-Цион", en: "Rishon Lezion", hebrew: "ראשון לציון" },
  { rus: "Рош-ха-Аин", en: "Rosh HaAyin", hebrew: "ראש העין" },
  { rus: "Сделана", en: "Sde Lana", hebrew: "סד לנה" },
  { rus: "Тверия", en: "Tiberias", hebrew: "טבריה" },
  { rus: "Тель-Авив", en: "Tel Aviv", hebrew: "תל אביב" },
  { rus: "Тель-Ягд", en: "Tel Yagid", hebrew: "תל יגיד" },
  { rus: "Тира", en: "Tira", hebrew: "טירה" },
  { rus: "Умм-эль-Фахм", en: "Umm el-Fahm", hebrew: "אום אל-פחם" },
  { rus: "Цфат", en: "Safed", hebrew: "צפת" },
  { rus: "Цфараим", en: "Tsfaraim", hebrew: "צפרים" },
  { rus: "Хадера", en: "Hadera", hebrew: "חדרה" },
  { rus: "Хайфа", en: "Haifa", hebrew: "חיפה" },
  { rus: "Шарона", en: "Sharona", hebrew: "שרונה" },
  { rus: "Шаар-ха-Галиль", en: "Shaar HaGalil", hebrew: "שער הגליל" },
  { rus: "Шдерот", en: "Sderot", hebrew: "שדרות" },
  { rus: "Эмек-Ярден", en: "Emek Yarden", hebrew: "עמק הירדן" }
];